import {AuthContextType, Division} from "../types/types";
import {get} from "./helpers/restHelpers";

export async function getDivisions(authContext: AuthContextType):Promise<Division[]> {
    const response = await get("/v1/divisions?size=100", authContext);
    return response.data.features as Division[];
}

